import { AdornisRouter } from '@adornis/base/client/a-router';
import { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element';
import { ObservableController } from '@adornis/chemistry/controllers/observable-controller';
import { css } from '@adornis/chemistry/directives/css';
import '@adornis/file-utils/client/x-image';
import '@adornis/germanium/components/ge-section';
import '@adornis/ghost/client/ghost-post-content';
import { Ghost } from '@adornis/ghost/db/ghost';
import { html } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { filter, switchMap } from 'rxjs/operators';
import './wtg-footer';

@customElement('wtg-post')
export class WTGPost extends ChemistryLitElement {
  styles = () => ({ ':host': { display: 'block' } });

  @state() postID = new ObservableController(this, AdornisRouter.get('postID'));
  @state() public post = new ObservableController(
    this,
    this.postID.observable.pipe(
      filter(Boolean),
      switchMap(postID => {
        console.log('test', postID);
        return Ghost.getPostByID(postID)(`{id title featureImage}`);
      }),
    ),
  );

  public render() {
    if (!this.postID.value || !this.post.value) return html``;
    return html`
      <x-flex space="xxl">
        <x-image
          is-url
          ?dummy=${!this.post.value.featureImage}
          .value=${this.post.value.featureImage}
          ${css({ width: '100%', height: '480px' })}
        ></x-image>

        <ge-section>
          <x-flex space="xl">
            <ge-h1> ${this.post.value.title} </ge-h1>
            <ghost-post-content
              post-id=${this.postID.value}
              .designSystemPrefix="${'ge'}"
              space="md"
            ></ghost-post-content>
          </x-flex>
        </ge-section>

        <wtg-footer></wtg-footer>
      </x-flex>
    `;
  }
}
